
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ThemeButton extends Vue {
  @Prop(Boolean) outlined!: boolean;
  @Prop(Boolean) block!: boolean;
  @Prop(Boolean) fullWidth!: boolean;
  @Prop(Boolean) text!: boolean;
}
